import React from "react";
import PropTypes from "prop-types";

const SimpleText = ({ children, className }) => <span className={className}>{children}</span>;

SimpleText.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

export default SimpleText;
